// extracted by mini-css-extract-plugin
export default {"table":"QualityTable_table__oWD-I","completed":"QualityTable_completed__TMKVp","inProgress":"QualityTable_inProgress__9XJlF","pending":"QualityTable_pending__GaI00"};